<template>
  <div
    class="w-64 2xl:w-88"
    v-clickOutside="hideFiligrane"
  >
    <div class="mb-3">
      <info-bulle-hover
        :name="'filename'+id"
        :libelle="filename" 
        :is-display-tooltip="isFilenameTooltipDisplay"
        position="bottom-3 left-0"
      /> 
      <h5 
        @mouseover="isFilenameTooltipDisplay = true"
        @mouseleave="isFilenameTooltipDisplay = false"
        class="text-left text-indigo-600 truncate w-full"
      >
        {{ filename }}
      </h5>
    </div>
    <div 
      :class="'relative h-64 2xl:h-88 rounded-md bg-gray-200'"
      @click.stop="showFiligrane"
      @mouseleave="hideFiligrane();"
      @mouseenter="showFiligrane();"
    >
      <!-- Filigrane -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div 
          class="top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default" 
          v-if="isFiligrane"
        >
          <!-- Filigrane contents -->
          <div 
            class="absolute right-4 top-4 p-2 cursor-pointer"
            @click.stop="displayMore()"
            v-if="editable && !isMoreDisplayed && !isDeleteDisplayed"
          >
            <icon
              name="more-vertical"
              class="text-white"
            />
          </div>
          <div 
            class="absolute right-6 top-6 flex space-x-3"
            v-if="isMoreDisplayed"
          >
            <div 
              v-if="editable"
              class="cursor-pointer"
              @click.stop="editFile()"
            >
              <icon
                name="edit"
                class="text-white"
              />
            </div>
            <div 
              v-if="editable"
              class="cursor-pointer"
              @click.stop="displayDelete()"
            >
              <icon
                name="trash-2"
                class="text-white"
              />
            </div>
          </div>

          <div 
            v-if="!isDeleteDisplayed"
            class="border border-pink-600 rounded-full
                            py-1.5 px-3.5 
                            flex justify-center  
                            text-white text-sm 
                            w-max cursor-pointer 
                            transition-all duration-300 hover:bg-white hover:text-indigo-600"
            @click.stop="openFile()"
          >
            Voir l'image
          </div>
          <div
            v-if="isDeleteDisplayed" 
            class="flex flex-col justify-center items-center space-y-5"
          >
            <div class="text-lg text-white">
              Supprimer l'image ?
            </div>
            <div class="flex flex-row space-x-2">
              <div
                class="
                                    border border-pink-600 rounded-md
                                    py-1.5 px-3.5 
                                    flex justify-center  
                                    text-white text-sm font-light
                                    w-max cursor-pointer 
                                    transition-all duration-300 
                                    hover:bg-white hover:text-pink-600 hover:border-transparent
                                "
                @click.stop="deleteFile"
              >
                Oui, Supprimer
              </div>
              <div 
                class="
                                    py-1.5 px-3.5 
                                    flex justify-center  
                                    text-white text-sm font-light 
                                    w-max cursor-pointer 
                                    transition-all duration-300 hover:text-indigo-300
                                "
                @click.stop="closeDelete"
              >
                Annuler
              </div>
            </div>
          </div>
          <!-- END Filigrane contents -->
        </div>
      </transition>
      <!-- END Filigrane -->
      <img 
        :src="'/portfolio/'+infosPass.id_pass+'/'+file.filename" 
        class="object-cover w-full h-full rounded-md"
        alt="" 
      >
    </div>
    <div
      v-if="file.description"
      class="text-sm mt-3.5 flex flex-col space-y-1"
    >
      <p class="text-pink-600">
        Description
      </p>
      <p class="text-gray-600 italic">
        {{ file.description }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from './../Icon';
import ClickOutside from 'vue-click-outside';
import Constants from './../../constants';
import InfoBulleHover from './../../components/InfoBulleHover';

export default {
  components:{
    Icon,
    InfoBulleHover,
  },

  props:{
    file:{
      type: Object,
      required:true,
    },

    editable:{
      type:Boolean,
    },
    id:{
      type: Number
    }
  },

  data(){
    return {
      constants: Constants,

      isMoreDisplayed: false,
      isDeleteDisplayed: false,
      isFiligrane: false,

      isFilenameTooltipDisplay: false,
    };
  },

  mounted(){

  },

  methods:{
    showFiligrane(){
      this.isFiligrane = true;
    },

    hideFiligrane(){
      this.isFiligrane = false;
      this.closeMore();
      this.closeDelete();
    },

    displayMore(){
      this.closeDelete();
      this.isMoreDisplayed = true;
    },

    closeMore(){
      this.isMoreDisplayed = false;
    },

    displayDelete(){
      this.closeMore();
      this.isDeleteDisplayed = true;
    },

    closeDelete(){
      this.isDeleteDisplayed = false;
    },

    openFile(){
      this.$emit('openFile');
    },
        
    downloadFile(){
      this.$emit('downloadFile');
    },

    editFile(){
      this.$emit('editFile');
    },

    deleteFile(){
      this.$emit('deleteFile');
    },
  },

  computed:{
    ...mapGetters({
      infosPass: 'neopass/infosPass',
    }),

    filename:{
      get:function(){
        return this.file.name;
      }
    }
  },

  directives: {
    ClickOutside
  }
};
</script>